export default "__VITE_ASSET__CKLevq8G__"